import {apiWithToken} from "../../../systems/api";
import {API_URL} from '../../../systems/globalContant';

export default {
    addRelatedTransaction: (transaction_id, data = {}) => apiWithToken.post(API_URL.DEFAULT + `/transaction-related/${transaction_id}`, data, {loading: false}),
    deleteRelatedTransaction: (transaction_id, transaction_related_id) => apiWithToken.delete(API_URL.DEFAULT + `/transaction-related/${transaction_id}/${transaction_related_id}`, {}, {loading: false}),
};